<script setup lang="ts">
import { useTutorApplicationStore } from '../model/store'
import FormBox from './FormBox.vue'
import UploadCv from './cv-or-resume/UploadCv.vue'

defineOptions({
  name: 'CvOrResume',
})

const tutorApplicationStore = useTutorApplicationStore()

const uploadCvRef = useTemplateRef<InstanceType<typeof UploadCv>>('uploadCvRef')

const setClear = (): void => {
  tutorApplicationStore.resetCv()
  uploadCvRef.value?.resetFiles()
}

</script>

<template>
  <FormBox
    title="CV or Resume"
    @click:clear="setClear"
  >
    <div class="cv-or-resume__upload">
      <UploadCv
        ref="uploadCvRef"
      />
    </div>
  </FormBox>
</template>
